var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-container',[_c('div',{staticClass:"block text-center notFound"},[_c('h2',[_vm._v("Página no encontrada")]),_c('i',{staticClass:"fas fa-exclamation-triangle red--text"}),_c('p',[_vm._v("Lo sentimos, pero esta página no está disponible")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }